import {
  getLexicalConfig,
  getWhatsappMarkdownTransformers,
} from "@jugl-web/domain-resources/common/components/RichTextarea";
import { $generateHtmlFromNodes } from "@lexical/html";
import { $convertFromMarkdownString } from "@lexical/markdown";
import { createEditor, CreateEditorArgs } from "lexical";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { useCallback, useId, useMemo } from "react";
import { useSupportedWhatsappVariables } from "@jugl-web/domain-resources/integrations";
import { WhatsappBody } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/types";
import { whatsappBodyToProcessedBody } from "../utils/whatsappBodyToProcessedBody";

export const useWhatsappTemplateBodyRenderer = (boardId?: string) => {
  const editorId = useId();
  const { entityId } = useEntitySelectedProvider();
  const { variables } = useSupportedWhatsappVariables(entityId, boardId);

  const editor = useMemo(
    () => createEditor(getLexicalConfig(editorId, false) as CreateEditorArgs),
    [editorId]
  );

  const renderHtml = useCallback(
    (whatsappBody: WhatsappBody) => {
      const processedBody = whatsappBodyToProcessedBody(whatsappBody);

      return new Promise<string>((resolve) => {
        editor.update(
          () => {
            $convertFromMarkdownString(
              processedBody,
              getWhatsappMarkdownTransformers(variables)
            );
          },
          {
            onUpdate: () => {
              const html = editor
                .getEditorState()
                .read(() => $generateHtmlFromNodes(editor));

              resolve(html);
            },
          }
        );
      });
    },
    [editor, variables]
  );

  return { renderHtml };
};
